import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { brand, heroContents, heroFacts, mockups } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="w-full bg-amber-50 pb-16 pt-12 md:pb-20 md:pt-16" data-id="element-92" data-mp="9lbfcytwl7cj">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-93" data-mp="4n1kyqg06arz">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="inline-flex items-center gap-2 rounded-full bg-pink-100 px-4 py-2 text-xs font-extrabold uppercase tracking-widest text-pink-700 ring-1 ring-pink-200" data-id="element-94" data-mp="12a0j75mcfqrz">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="nbop96qcuw4i" />
          {brand.tag}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl text-4xl font-extrabold leading-none tracking-tight text-neutral-800 sm:text-5xl md:text-6xl" data-id="element-96" data-mp="3d33f4zea6vla">
          Trasforma la tua iniziativa di Ottobre Rosa in{' '}
          <span className="bg-pink-200 px-1.5 pb-0.5 leading-tight text-pink-950" data-id="element-97" data-mp="399b9pjftv5tv">
            un momento capace di sensibilizzare, coinvolgere e lasciare un segno
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease
      }} className="mx-auto mt-6 max-w-3xl text-xl font-bold leading-snug text-neutral-600 md:text-2xl" data-id="element-98" data-mp="30gzw4y5tbcvb">
          Un kit attività 3-in-1 con 50 Carte di Riflessione, 150 Segnalibri Ispirazionali e una
          Guida Pratica alle Attività di 50 pagine, pronti da stampare e utilizzare.
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.14,
        ease
      }} src={mockups.kit} alt="Kit Attività Ottobre Rosa 3-in-1: 50 Carte di Riflessione, 150 Segnalibri Ispirazionali, Guida Pratica alle Attività di 50 pagine + 3 Bonus" className="mx-auto mt-10 w-full max-w-3xl rounded-3xl shadow-xl" width={1024} height={1024} data-id="element-99" data-mp="2lla5untlgdks" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease
      }} className="mx-auto mt-11 max-w-3xl" data-id="element-100" data-mp="1b0nk5sx3a94y">
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-neutral-500" data-id="element-101" data-mp="111ycsu2tk72y">
            Tutto ciò che ti serve per organizzare un’iniziativa Ottobre Rosa più coinvolgente,
            partecipativa e curata, senza dover partire da zero.
          </p>

          <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm font-extrabold uppercase tracking-wide text-pink-900" data-id="element-102" data-mp="3lqm2xztl37vg">
            {heroContents.map((item, index) => <li key={item} className="inline-flex items-center gap-3" data-id="element-103" data-mp="1x7hxtje7id3i" data-mpi={index}>
                {index > 0 && <span className="h-1 w-1 rounded-full bg-amber-400" aria-hidden="true" data-id="element-104" data-mp="269zfdkix2hk6" />}
                {item}
              </li>)}
          </ul>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm font-semibold text-neutral-500" data-id="element-105" data-mp="2b2snmidlg810">
            {heroFacts.map((fact, index) => <li key={fact} className="inline-flex items-center gap-3" data-id="element-106" data-mp="2kxc75qzbhjj0" data-mpi={index}>
                {index > 0 && <span className="h-1 w-1 rounded-full bg-amber-400" aria-hidden="true" data-id="element-107" data-mp="2p1a4bw530k9f" />}
                {fact}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}